import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { FiAlertTriangle } from 'react-icons/fi';

// Standardwerte noetig: ohne sie leitet TypeScript (checkJs) beide Props als
// "Pflicht" ab und jeder Aufruf ohne "name" erzeugt einen Typfehler.
const SafeIcon = ({ icon = null, name = null, ...props }) => {
  let IconComponent;
  try {
    IconComponent = icon || (name && FiIcons[`Fi${name}`]);
  } catch (e) {
    IconComponent = null;
  }

  return IconComponent
    ? React.createElement(IconComponent, props)
    : <FiAlertTriangle {...props} />;
};

export default SafeIcon;